import { StorageKey } from "../config/Constants"

const expirationTimeout: number = 15 * 60 * 1000 // 15 minutes in milliseconds
export const ProcessingCollectionLabel = "Processing Collection"

interface CachedCollectionTest {
  id: string
  timestamp: number
}

function getCachedCollectionTests(): CachedCollectionTest[] {
  return JSON.parse(sessionStorage.getItem(StorageKey.CachedCollectionTests) || "[]")
}

function getProcessingCollectionTests(): CachedCollectionTest[] {
  const tests: CachedCollectionTest[] = getCachedCollectionTests()
  return tests.filter((test: CachedCollectionTest) => test.timestamp + expirationTimeout > Date.now())
}

function setProcessingCollectionTests(tests: CachedCollectionTest[]) {
  sessionStorage.setItem(StorageKey.CachedCollectionTests, JSON.stringify(tests))
}

export function addProcessingCollectionTest(id: string) {
  let tests: CachedCollectionTest[] = getProcessingCollectionTests()
  const test: CachedCollectionTest = {id: id, timestamp: Date.now() }
  tests.push(test)
  setProcessingCollectionTests(tests)
}

export function refreshProcessingCollectionTests() {
  setProcessingCollectionTests(getProcessingCollectionTests())
}

export function isProcessingCollection(id: string) {
  const tests: CachedCollectionTest[] = getProcessingCollectionTests()
  return tests.map(test => test.id).includes(id)
}

export function hasCachedCollectionTests() {
  return getCachedCollectionTests().length > 0
}
